import http from "@/untils/http"
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = ""
// let resquest = http.retuest

export default {
    getSchoolAPI(params) {
        return http.post(`${resquest}/trainapi/query_sysCollegeConfig_college`,params)
    },
    getSchoolAPI01(params) {
        return http.post(`${resquest}/trainapi/query_sysCollegeConfig_by_college`,params)
    },
    postWebNavAPI(params) {
        return http.post(`${resquest}/trainapi/query_college_web_nav_pc`,params)
    },
    postLoginAPI(params) {
        return http.post(`${resquest}/userapi/login_college`,params)
    },
    checkAPI(params){
        return http.post(`${resquest}/userapi/check_user_by_college_mark`,params)
    },
    logoutAPI(params) {
        return http.post(`${resquest}/userapi/login_out_college`,params)
    },   
    useractiveStart(params) {
        return http.post(`${resquest}/userapi/activeStart`,params)
    },
    useractiveEnd(params) {
        return http.post(`${resquest}/userapi/activeEnd`,params)
    },
    userAddActiveRecord(params) {
        return http.post(`${resquest}/userapi/addActiveRecord`,params)
    }
}